import EditButtonsPopup from './edit-button-popup'

export default EditButtonsPopup
